module.exports = __webpack_public_path__ + "static/media/alternator-stering-and-replacement-red.b4780c59.svg";